<template>
<transition name="ws-actionsheet-pop">
<div class="ws-actionsheet" v-show="visible" @click="close" >
    <div class="ws-actionsheet-wrapper">
      <ul>
        <li style="text-align:center;font-size:18px;height:45px;line-height:45px;color:rgb(68, 85, 102)!important;font-weight:bold;" v-for="item in itemArray" @click="item.method"><img style="display:inline-block;height:22px;width:22px;vertical-align:text-top;margin-right:4px;" :src="item.img" alt="">{{item.text}}</li>
        <li style="text-align:center;font-size:18px;height:45px;line-height:45px;color:rgb(68, 85, 102)!important;font-weight:bold;" @click="close">取消</li>
        <!-- <li><i class="icon icon-clock"></i><router-link to="/bookcase/1">阅读记录</router-link></li>
        <li><i class="icon icon-index"></i><router-link to="/bookstorage">返回首页</router-link></li> -->
      </ul>
      <div style="height:50px;"></div>
    </div>
  </div>
</transition>
  
</template>

<script>
export default {
  props: {
    itemArray: Array,
    visible: Boolean,
    close:Function
  },
  data() {
    return {
    };
  },
  created() {
    this.init();
    console.log("actionsheet created");
    console.log(this.visible);
  },
  methods: {
    init() {

    },
    // close(evt) {
    //   this.visible=false;
    //   if (
    //     evt.target.className != "ws-actionsheet" &&
    //     evt.target.className != "li-cancel"
    //   )
    //     return;
    //   this.$parent.menuVisbile = false;
    // }
  }
};
</script>

<style scoped>
.ws-actionsheet {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  transition: opacity 0.2s linear;
}
.ws-actionsheet-wrapper {
  position: fixed;
  width: 100%;
  background: #ffffff;
  color: #333;
  bottom: 0;
  left: 0;
}
.ws-actionsheet-wrapper ul {
  padding: 0 1rem;
}
.ws-actionsheet-wrapper ul li {
  height: 3.33rem;
  border-top: 1px solid #d6d6d6;
  line-height: 3.33rem;
}
.ws-actionsheet-wrapper ul li .icon {
  margin-right: 0.5rem;
  font-size: 1rem;
}
.ws-actionsheet-wrapper ul li:first-child {
  height: 3.33rem;
  border-top: 0px solid #d6d6d6;
  line-height: 3.33rem;
}
.li-cancel {
  height: 3.33rem;
  border-top: 5px solid #868686;
  line-height: 3.33rem;
  color: #f76c5b;
}
.ws-actionsheet-pop-enter,
.ws-actionsheet-pop-leave-active {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/actionsheet.vue